import React from 'react';

// Icones du menu (celles de la maquette docs/bookipix-admin.html), en SVG integre : aucune bibliotheque d'icones.
const TRACES = {
  home: <path d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10" />,
  bag: <path d="M5 8h14l-1 12H6L5 8zM9 8V6a3 3 0 016 0v2" />,
  book: <path d="M5 4h11a3 3 0 013 3v13H8a3 3 0 01-3-3V4zM5 17a3 3 0 013-3h11" />,
  users: (
    <>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M16 5a3 3 0 010 6M18 14.8c1.8.7 3 2.3 3 5.2" />
    </>
  ),
  truck: (
    <>
      <path d="M2 6h12v10H2zM14 10h4l4 3v3h-8" />
      <circle cx="7" cy="17.5" r="2" />
      <circle cx="18" cy="17.5" r="2" />
    </>
  ),
  box: <path d="M3 7l9-4 9 4v10l-9 4-9-4V7zM3 7l9 4 9-4M12 11v10" />,
  tag: (
    <>
      <path d="M3 12V4h8l10 10-8 8L3 12z" />
      <circle cx="7.5" cy="8.5" r="1.3" />
    </>
  ),
  chart: <path d="M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-6" />,
  mail: <path d="M3 6h18v12H3zM3 7l9 6 9-6" />,
  server: (
    <>
      <rect x="3" y="4" width="18" height="7" rx="2" />
      <rect x="3" y="13" width="18" height="7" rx="2" />
      <path d="M7 7.5h.01M7 16.5h.01" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l5 5" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  x: <path d="M6 6l12 12M18 6L6 18" />,
  warn: <path d="M12 3l10 18H2L12 3zM12 10v5M12 18h.01" />
};

export default function AdminIcon({ name }) {
  return (
    <svg className="adm-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {TRACES[name] || null}
    </svg>
  );
}
